<template>
  <div class="header">
    <div class="hea_box">
      <div class="logo">
        <img src="./image/logo3.png" alt="四川大学" />
      </div>
      <div class="Web_title">
          <h2>高等学历继续教育（网络教育）</h2>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {}
  }
};
</script>

<style scoped lang="scss">
.header {
  width: 100%;
  height: 100px;
  background-color: #bb2a17;
  .hea_box {
    width: 1200px;
    height: 100px;
    margin: 0 auto;
    background:url("./image/logoRight_02.jpg") no-repeat top right;
    & > div {
      float: left;
    }
    .logo {
      height: 86px;
      width: 370px;
      margin-top: 8px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .Web_title{
      height: 100px;
      width: 430px;
      margin-left: 70px;
      h2{
        margin: 0;
        height: 100px;
        line-height: 100px;
        color: #fff;
        font-family: '宋体','Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
        font-size: 30px;
      }
    }
  }
}
</style>
